import { useEffect, useState } from "react";

import {
    CustomizedDatePicker,
    CustomizedFormGroupTitle,
    CustomizedRadioButton,
    CustomizedSelectDropdown,
    CustomizedTextArea,
    CustomizedTextInput,
    CustomizedCheckBox,
    CustomizedAutoComplete
} from "../../components";
import { Constant } from "../../constants";
import { translate } from "../TranslateStringValue";

const DynamicFormTemplate = (props) => {
    const {
        isHidden,
        formData,
        defaultValue,
        error
    } = props;

    const [elements, setElements] = useState([])

    const renderForm = () => {
        const form = []
        formData.forEach((f, index) => {
            switch (f.typehtml) {
                case 'title':
                    form.push(<CustomizedFormGroupTitle key={index} label={f.label} />)
                    break
                case 'hidden':
                    form.push(<input
                        key={index} 
                        type="hidden" 
                        name={f.name} 
                        id={f.name} 
                        defaultValue={defaultValue[f.name.split("-").join("_")]} 
                    />)
                    break
                case "text":
                    form.push(<CustomizedTextInput
                        key={index}
                        label={f.label}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "radio":
                    form.push(<CustomizedRadioButton
                        key={index}
                        label={f.label}
                        liste_valeurs={f.liste_valeurs}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "select":
                    form.push(<CustomizedSelectDropdown
                        key={index}
                        label={f.label}
                        liste_valeurs={f.liste_valeurs}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "checkbox":
                    form.push(<CustomizedCheckBox
                        key={index}
                        label={f.label}
                        liste_valeurs={f.liste_valeurs}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "textarea":
                    form.push(<CustomizedTextArea
                        key={index}
                        label={f.label}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "date":
                    form.push(<CustomizedDatePicker
                        key={index}
                        label={f.label}
                        name={f.name}
                        required={translate(f.requis)}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />)
                    break
                case "autocomplete":
                    const el = <CustomizedAutoComplete
                        key={index}
                        freeSolo={f.allowFreeText}
                        name={f.name}
                        label={f.label}
                        options={f.options}
                        displayAllOption={f.displayAllOption}
                        required={translate(f.requis)}
                        onChange={(e, newValue) => {
                            if (newValue) {
                                window.dispatchEvent(new CustomEvent(Constant.event.selectAutoCompleteOption, { detail: { key: f.key, name: f.name, data: newValue } }))
                            }
                        }}
                        value={defaultValue[f.name.split("-").join("_")]}
                        error={error ? error[f.name] : false}
                        schema={f}
                    />
                    form.push(el)
                    break
            }
        })

        setElements(form)
    }

    useEffect(() => {
        renderForm()
    }, [])

    useEffect(() => {
        renderForm()
    }, [defaultValue])

    useEffect(() => {
        renderForm()
    }, [error])

    return <div style={{ display: isHidden ? "none" : "block" }}>{elements}</div>
}

export default DynamicFormTemplate;